var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#F7EDE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 37.0001C29.2501 37.0001 27.0001 34.7501 27.0001 32.0001C27.0001 29.2501 29.2501 27.0001 32.0001 27.0001V16.1667C23.2501 16.1667 16.1667 23.2501 16.1667 32.0001C16.1667 40.7501 23.2501 47.8334 32.0001 47.8334C35.6667 47.8334 39.0834 46.5834 41.8334 44.4168L35.1667 35.9168C34.2501 36.5834 33.1667 37.0001 32.0001 37.0001Z",
    fill: "#00BCD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 32.0001H47.8333C47.8333 23.2501 40.75 16.1667 32 16.1667V27.0001C34.75 27.0001 37 29.2501 37 32.0001Z",
    fill: "#448AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8333 32H36.9999C36.9999 33.5833 36.2499 35 35.0833 35.9167L41.7499 44.4167C45.4999 41.5 47.8333 37 47.8333 32Z",
    fill: "#3F51B5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.ae9b0bb3008568201306e723c9354e32.svg";
export { ForwardRef as ReactComponent };